import { campaignsConstants } from '@constants/campaigns';

const initialState = {
    data: [],
    loading: true,
    error: '',
    totalCount: 0,
    pages: 1,
};

export function campaigns(state = initialState, action) {
    switch (action.type) {
        case campaignsConstants.CAMPAIGNS_FETCH:
            return { ...state, loading: true, error: '' };
        case campaignsConstants.CAMPAIGNS_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.data.items,
                totalCount: action.data.totalCount,
                pages: action.data.pages,
                error: '',
            };
        case campaignsConstants.CAMPAIGNS_ERROR:
            return { ...state, error: action.message, loading: false };
        case campaignsConstants.SET_CAMPAIGNS:
            return { ...state, data: action.data };
        default:
            return state;
    }
}
